import { render, staticRenderFns } from "./iconCategories.vue?vue&type=template&id=b0793d12&scoped=true"
import script from "./iconCategories.vue?vue&type=script&lang=js"
export * from "./iconCategories.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0793d12",
  null
  
)

export default component.exports